import { render, staticRenderFns } from "./SalesDataTable.vue?vue&type=template&id=5b8ea9d8&"
import script from "./SalesDataTable.vue?vue&type=script&lang=js&"
export * from "./SalesDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports